import { ToolBase } from ".";

const fabric = require("../fabric").fabric;

export class DragTool extends ToolBase {

  /**
   * @inheritdoc
   */
  registerEvents() {
    let that = this;
    let canvas = this.imageEditor.canvas;
    let isGestureEvent = false;
    let initialzoom = 0;
    let initialZoomPoint = null;

    canvas.on('touch:gesture',function(event){
      if(!that.isActive) return;

      if(!isGestureEvent) {
        let touches = event.self.touches;
        initialzoom = canvas.getZoom();
        initialZoomPoint = new fabric.Point((touches[0].x + touches[1].x) / 2, (touches[0].y + touches[1].y) / 2);
      }

      isGestureEvent = true;     

      var lPinchScale = event.self.scale;  
      var scaleDiff = (lPinchScale -1)/1 + 1;

      canvas.zoomToPoint(initialZoomPoint, initialzoom*scaleDiff)

      canvas.requestRenderAll();
    });

    canvas.on('mouse:down', function(opt) {
      if(!that.isActive || isGestureEvent) return;

      this.isDragging = true;
      this.selection = false;
      this.lastPosX = opt.pointer.x;
      this.lastPosY = opt.pointer.y;
    });

    canvas.on('touch:drag', function(opt) {
      if(!that.isActive || isGestureEvent) return;

      if (this.isDragging) {
        var vpt = this.viewportTransform;
        vpt[4] += opt.self.x - this.lastPosX;
        vpt[5] += opt.self.y - this.lastPosY;
        this.requestRenderAll();
        this.lastPosX = opt.self.x;
        this.lastPosY = opt.self.y;
      }
    });

    canvas.on('mouse:move', function(opt) {
      if(!that.isActive || isGestureEvent) return;
      
      if (this.isDragging && opt.e.clientX !== undefined) {
        var e = opt.e;
        var vpt = this.viewportTransform;
        vpt[4] += e.clientX - this.lastPosX;
        vpt[5] += e.clientY - this.lastPosY;
        this.requestRenderAll();
        this.lastPosX = e.clientX;
        this.lastPosY = e.clientY;
      }
    });

    canvas.on('mouse:up', function(opt) {
      if(!that.isActive) return;
      
      this.setViewportTransform(this.viewportTransform);
      this.isDragging = false;
      this.selection = true;
      isGestureEvent = false;
      this.initialZoomPoint = null;
    });
  }

}